export default "__VITE_ASSET__s_R63b1J__"